import jsPDF from 'jspdf'

// Use Sarabun Regular for both normal and bold variants so autoTable headers
// (which request 'bold' by default) still render Thai glyphs correctly.
const FONT_URL_REGULAR =
  'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/sarabun/Sarabun-Regular.ttf'
const FONT_URL_BOLD =
  'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/sarabun/Sarabun-Bold.ttf'

const FONT_NAME = 'Sarabun'
const VFS_REGULAR = 'Sarabun-Regular.ttf'
const VFS_BOLD = 'Sarabun-Bold.ttf'

let cachedRegular: string | null = null
let cachedBold: string | null = null

async function toBase64(url: string): Promise<string> {
  const response = await fetch(url)
  if (!response.ok) throw new Error(`Failed to load Thai font: ${response.status}`)
  const buffer = await response.arrayBuffer()
  return btoa(
    new Uint8Array(buffer).reduce((data, byte) => data + String.fromCharCode(byte), '')
  )
}

async function loadFonts(): Promise<{ regular: string; bold: string }> {
  if (!cachedRegular) cachedRegular = await toBase64(FONT_URL_REGULAR)
  if (!cachedBold) cachedBold = await toBase64(FONT_URL_BOLD)
  return { regular: cachedRegular, bold: cachedBold }
}

/**
 * Creates a jsPDF instance with Sarabun (Thai) font pre-loaded for both
 * normal and bold styles. Bold is needed for autoTable header cells.
 */
export async function createThaiPDF(): Promise<jsPDF> {
  const { regular, bold } = await loadFonts()
  const doc = new jsPDF()
  doc.addFileToVFS(VFS_REGULAR, regular)
  doc.addFont(VFS_REGULAR, FONT_NAME, 'normal')
  doc.addFileToVFS(VFS_BOLD, bold)
  doc.addFont(VFS_BOLD, FONT_NAME, 'bold')
  doc.setFont(FONT_NAME, 'normal')
  return doc
}

/** Default autoTable cell styles with Thai font support */
export const thaiTableStyles = {
  font: FONT_NAME,
  fontStyle: 'normal' as const,
  fontSize: 8,
}

/** Default autoTable head styles with Thai font support */
export const thaiHeadStyles = {
  font: FONT_NAME,
  fontStyle: 'bold' as const,
}
